import { render, staticRenderFns } from "./PublicApp.vue?vue&type=template&id=0a7d6a66&"
import script from "./PublicApp.vue?vue&type=script&lang=js&"
export * from "./PublicApp.vue?vue&type=script&lang=js&"
import style0 from "./PublicApp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports